// OurTeamSection.jsx
import React from "react";
import "./OurTeamSection.css";

import ChengTao from "../assets/images/chengtao.png"

import { motion } from "framer-motion";

const OurTeamSection = () => {
  return (
    <motion.section
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
            >
    <section className="team-section">
      <div className="container-teams">
        <h2 className="section-title-teams">Our team</h2>
        <p className="subtitle">
          The right tools wielded by the right people to make anything possible.
        </p>

        <div className="team-grid">
          <div className="profile-image">
            <img
              src={ChengTao}
              alt="Professor Tao Cheng"
              className="avatar"
            />
          </div>
          <div className="profile-info">
            <h3 className="name">Professor Tao Cheng</h3>
            <h4 className="title">
              Founder, Director & CEO, Professor of Geoinformatics, PhD, FAcSS, FICE, FRGS
            </h4>
            <ul className="bio-list">
            <motion.p
                initial={{ x: 100 }} 
                whileInView={{ x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                >
              <li>
                Vice-Dean (International), Faculty of Engineering Sciences, University College London
              </li>
              
              
              <li>
                Professor of Geoinformatics, Department of Civil, Environmental and Geomatics Engineering, University College London (2020 QS world ranking 8th)
              </li>
              <li>
                Founding Director, SpaceTimeLab, Department of Civil, Environmental & Geomatic Engineering, University College London
              </li>
              <li>
                Founder and Director of UCL SpaceTimeLab for Big Data Analytics, a world's leading geo-computing centre found in 2012.
              </li>
              <li>
                Theme Lead in Mobility, The Alan Turing Institute
              </li>
              <li>
                Member, College of Experts, UK Department for Transport
              </li>
              <li>
                Recipient of 20m+ GBP research grants from leading research funders (e.g, EPSRC)
              </li>
              <li>
                Author of 250+ scientific research papers
              </li>
              <li>
                Global leading researcher in network complexity, geocomputation, spatio-temporal analytics with applications in transport, crime, health, business, social media, and natural hazards.
              </li>
              <li>
                Strong working relationship with major UK public bodies (e.g., Transport for London, London Metropolitan Police Service and Public Health England).
              </li>
              <li>
                Rich experience working with enterprises on the development of bespoke AI-enabled big data solutions (Arup, British Gas, etc)
              </li>
              <li>
                iHotSpot nominated as a finalist at The Engineer 'Collaborate to Innovate' award.
              </li>
              </motion.p>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </motion.section>
  );
};

export default OurTeamSection;